module.exports = __webpack_public_path__ + "static/media/W240.320e0d36.png";